module.exports = __webpack_public_path__ + "static/claims4-59d9f43408a8b174084175422fdba6c2.svg";